import { api } from './config';

export const fetchAllActivities = async () =>
  await api.get(`/activities`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
